import { createActionCreator } from '../../utils/helpers';
import { signup } from './types';

export const requestSignup = createActionCreator(signup.request, 'payload');
export const requestSignupSuccess = createActionCreator(signup.success, 'response');
export const requestSignupFailure = createActionCreator(signup.failure, 'error');
